import { isValidEmail } from '@/partials/el.Utils.js';

class EmailSignupBanner {
  constructor(bannerElement) {
    this.container = bannerElement;
    this.formContainer = this.container.querySelector('.el-email-signup-banner__form');
    this.inputAndButtonContainer = this.container.querySelector('.el-email-signup-banner__input-and-button-container');
    this.formErrorContainer = this.container.querySelector('.el-email-signup-banner__form-error');
    this.formSuccessContainer = this.container.querySelector('.el-email-signup-banner__form-success');
    this.input = this.container.querySelector('.el-email-signup-banner__form-input');
    this.button = this.container.querySelector('.el-email-signup-banner__form-button');

    if (!this.formContainer || !this.input || !this.button || !this.inputAndButtonContainer) {
      console.error('Email Signup Banner: Could not find all required elements (form, input, button).');
      return;
    }

    this.init();
  }

  init() {
    this.input.addEventListener('input', () => {
      this.toggleButtonVisibility();
      this.toggleErrorContainer(false);
    });

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.handleSubmit();
    });

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.handleSubmit();
      }
    });
  }

  toggleErrorContainer(showError) {
    this.formErrorContainer.classList.toggle('is-visible', showError);
  }

  toggleButtonVisibility() {
    const hasText = this.input.value.length > 0;
    this.button.classList.toggle('is-visible', hasText);
  }

  async handleSubmit() {
    const emailAddress = this.input.value.trim();

    if (!isValidEmail(emailAddress)) {
      this.toggleErrorContainer(true);
      return;
    }

    this.setLoading(true);

    const klaviyoData = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'VMhRSB',
            },
          },
        },
      },
    };

    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=YsJjdr', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2025-04-15',
        },
        body: JSON.stringify(klaviyoData),
      });

      if (response.ok) {
        this.handleSuccess();
      } else {
        throw new Error('Klaviyo API Error');
      }
    } catch (error) {
      console.error('Klaviyo Subscription Error:', error);
      this.toggleErrorContainer(true);
    } finally {
      this.setLoading(false);
    }
  }

  handleSuccess() {
    this.inputAndButtonContainer.style.display = 'none';
    this.formSuccessContainer.classList.add('is-visible');
  }

  setLoading(isLoading) {
    this.input.disabled = isLoading;
    this.button.disabled = isLoading;
    this.input.style.opacity = isLoading ? '0.5' : '1';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const emailSignupBanners = document.querySelectorAll('.el-email-signup-banner');
  emailSignupBanners.forEach((bannerElement) => {
    void new EmailSignupBanner(bannerElement);
  });
});
